// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1241":"1e69e967","4462":"b5e350c8"}[chunkId] + ".chunk.css";
};